
<div class="base_analytics_section-header">
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54"
        viewBox="0 0 54 54" fill="none">
        <rect width="54" height="54" rx="27" fill="#FFCCCC" />
        <path
            d="M40.9992 21.2772L40.6722 25.9289C40.661 26.08 40.583 26.2187 40.4579 26.3054C40.3736 26.3649 40.2733 26.3946 40.173 26.3946C40.1259 26.3946 40.0776 26.3884 40.0305 26.3736L35.5596 25.0518C35.375 24.9973 35.2375 24.8412 35.2065 24.6504C35.1756 24.4597 35.2573 24.2689 35.4159 24.1586L36.5692 23.3584L32.6793 17.7566L28.569 20.6083C28.341 20.7656 28.0301 20.7099 27.8715 20.4819L22.6389 12.9437C22.5633 12.8347 22.5336 12.6997 22.5571 12.5696C22.5807 12.4396 22.655 12.3231 22.764 12.2476L24.4339 11.0893C24.6618 10.932 24.9727 10.9877 25.1313 11.2157L28.9194 16.675L33.0285 13.8246C33.2552 13.6673 33.5674 13.723 33.7259 13.9509L39.06 21.635L40.2133 20.8335C40.3719 20.7233 40.5788 20.7146 40.7473 20.81C40.9145 20.9017 41.0124 21.085 40.9987 21.277L40.9992 21.2772ZM34.5872 38.7304C34.5872 40.5762 33.0857 42.0777 31.2411 42.0777C29.3953 42.0777 27.8938 40.5763 27.8938 38.7304C27.8938 36.8859 29.3952 35.3844 31.2411 35.3844C33.0857 35.3856 34.5872 36.8871 34.5872 38.7304ZM31.7417 38.2473V37.5474H32.6955C32.9718 37.5474 33.1972 37.3232 33.1972 37.0457C33.1972 36.7695 32.973 36.5453 32.6955 36.5453H31.7417V36.3433C31.7417 36.0671 31.5174 35.8416 31.2412 35.8416C30.9649 35.8416 30.7395 36.0659 30.7395 36.3433V36.5626C29.9058 36.6629 29.2876 37.2093 29.2876 37.8906C29.2876 38.5694 29.907 39.117 30.7395 39.2161V39.9172H29.8067C29.5304 39.9172 29.3062 40.1414 29.3062 40.4189C29.3062 40.6952 29.5304 40.9194 29.8067 40.9194H30.7395V41.1213C30.7395 41.3976 30.9637 41.6218 31.2412 41.6218C31.5174 41.6218 31.7417 41.3988 31.7417 41.1213V40.9033C32.5766 40.8029 33.1972 40.2554 33.1972 39.5753C33.196 38.894 32.5766 38.3464 31.7417 38.2473ZM33.9826 35.3597C34.2985 35.6161 34.5785 35.9184 34.8114 36.2529H38.6864V28.7692H33.9827L33.9826 35.3597ZM30.2887 37.8893C30.2887 37.9797 30.4584 38.1334 30.7396 38.199V37.5784C30.4584 37.644 30.2887 37.7989 30.2887 37.8893ZM31.7418 39.885C32.0242 39.8194 32.1952 39.6645 32.1952 39.5741C32.1952 39.4836 32.0255 39.33 31.7418 39.2644V39.885ZM20.0016 33.8386H14.6215V39.5841C14.6215 39.8293 14.8284 40.0375 15.0749 40.0375H20.9269V32.3483L20.4673 33.5202C20.3918 33.7122 20.2073 33.8386 20.0016 33.8386ZM20.6941 30.1989H14.0344L13 32.8363H19.6597L20.6941 30.1989ZM23.1965 32.8363H29.8549L28.8205 30.1989H22.1621L23.1965 32.8363ZM28.5629 35.3089V33.8385H22.8546C22.649 33.8385 22.4631 33.7121 22.3876 33.5201L21.9292 32.3495V40.0373H27.0937C26.9636 39.6248 26.8942 39.1863 26.8942 38.7316C26.893 37.343 27.5471 36.1055 28.5629 35.3089ZM30.5883 33.8385H29.5639V34.7205C30.0804 34.5037 30.6466 34.3835 31.24 34.3835C31.8581 34.3835 32.4478 34.5136 32.9805 34.7477L32.9817 25.6613H28.2768V29.198H29.1625C29.3681 29.198 29.554 29.3243 29.6283 29.5163L31.0554 33.156C31.1161 33.3096 31.0963 33.4843 31.0034 33.6206C30.9092 33.7568 30.7556 33.8385 30.5883 33.8385ZM22.5722 22.6806V29.1967H27.2747V22.6806H22.5722ZM16.8677 29.1967H21.5701V15.7497H16.8677V29.1967Z"
            fill="#FF0000" />
    </svg>
    <span i18n="@@storefront_analytics.least_popular_products">Least popular products</span>
</div>
<div class="base_analytics_section-body">
    <!-- Purchases Section -->
    <div class="d-flex flex-column w-100">
        <h4 class="mb-3" i18n="@@storefront_analytics.by_purchases">By purchases</h4>
        <div *ngFor="let item of purchasesData" class="analytics_card">
            <img [src]="item.img" alt="item" (error)="onImgError(item)" class="item-image" loading="lazy"/>
            <div class="d-flex flex-column w-100 gap-2">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <span class="name">{{ item.name }}</span>
                    <!-- <span class="price">{{ item.price }}</span> -->
                    <div>
                        <span [innerHtml]="item?.currency_symbol"></span>
                        <span class="price">  {{item.amount}}</span>
                    </div>
                </div>
                <span class="counter">{{ item.sold }}</span>
                <!-- <div class="d-flex align-items-center gap-2">
                    <div class="counter_persent"
                        [ngStyle]="{ color: item.iconColor }">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none">
                            <path
                                d="M10.5407 8.41748L6.99982 11.9583L3.45898 8.41748"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M7 2.04169V11.8592"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        {{ item.percent }}
                    </div>
                    <span class="period">{{ item.period }}</span>
                </div> -->
            </div>
        </div>
    </div>

    <!-- Clicks Section -->
    <div class="d-flex flex-column w-100">
        <h4 class="mb-3" i18n="@@storefront_analytics.by_clicks">By clicks</h4>
        <div *ngFor="let item of clicksData" class="analytics_card">
            <img [src]="item.img" alt="item" (error)="onImgError(item)" class="item-image" loading="lazy"/>
            <div class="d-flex flex-column w-100 gap-2">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <span class="name">{{ item.name }}</span>
                    <!-- <span class="price">{{ item.price }}</span> -->
                    <div>
                        <span [innerHtml]="item?.currency_symbol"></span>
                        <span class="price">  {{item.amount}}</span>
                    </div>
                </div>
                <span class="counter">{{ item.clicks }}</span>
                <!-- <div class="d-flex align-items-center gap-2">
                    <div class="counter_persent"
                        [ngStyle]="{ color: item.iconColor }">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none">
                            <path
                                d="M10.5407 8.41748L6.99982 11.9583L3.45898 8.41748"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M7 2.04169V11.8592"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        {{ item.percent }}
                    </div>
                    <span class="period">{{ item.period }}</span>
                </div> -->
            </div>
        </div>
    </div>
</div>
